import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function Others(props) {
  return (
    <>
      <Row>
        <Col>
          <Input
            type="checkbox"
            params="additions.others.emulsifiers"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Utiliza Emulsificantes"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            type="checkbox"
            params="additions.others.pigmentation"
            item={props.broiler}
            setItem={props.setBroiler}
            label={` Utiliza Pigmentante
            ${props.broiler.additions.others.pigmentation ? ", Qual" : ""}?`}
            className="kt-checkbox pr-15"
          />
          {props.broiler.additions.others.pigmentation && (
            <Input
              type="input"
              label=" "
              params="additions.others.pigmentationType"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder={
                props.broiler.additions.others.pigmentation
                  ? "Digite o pigmentante"
                  : ""
              }
              disabled={!props.broiler.additions.others.pigmentation}
            />
          )}
        </Col>
      </Row>
      {props.broiler.additions.others.pigmentation && (
        <Row>
          <Col>
            <Table>
              <Header>
                <tr>
                  <th style={{ width: "185px" }}>
                    <span></span>
                  </th>
                  <th>
                    <span>Qual PPM Amarelo?</span>
                  </th>
                  <th>
                    <span>Qual PPM Vermelho?</span>
                  </th>
                </tr>
              </Header>
              <Body>
                <tr>
                  <td>
                    <span>Pré</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.pre.yellowppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.pre.redppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Inicial</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.initial.yellowppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.initial.redppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Crescimento 1</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.growth.yellowppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.growth.redppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Crescimento 2</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.growth2.yellowppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.growth2.redppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Final</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.final.yellowppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.final.yellowppm"
                      item={props.broiler}
                      setItem={props.setBroiler}
                    />
                  </td>
                </tr>
              </Body>
            </Table>
          </Col>
        </Row>
      )}
    </>
  );
}
